import styles from "./HomeTopics.module.css";

const TOPICS = [
    { name: "Python", count: "6 courses" },
    { name: "Web Development", count: "6 courses" },
    { name: "Data Science", count: "4 courses" },
    { name: "Programming languages", count: "6 courses" },
    { name: "Startups", count: "5 courses" },
    { name: "Cloud & DevOps", count: "5 courses" },
];

function HomeTopics () {
    return (
        <section className={ styles.hpTopics }>
            <div className={ styles.hpSectionHeader }>
                <div className={ styles.hpSectionEyebrow }>Explore</div>
                <h2 className={ styles.hpSectionTitle }>Pick your path</h2>
                <p className={ styles.hpSectionSub }>From first line of code to production-ready skills.</p>
            </div>
            <div className={ styles.hpTopicsGrid }>
                {TOPICS.map((t) => (
                    <div className={ styles.hpTopicCard } key={t.name}>
                        <div className={ styles.hpTopicName }>{t.name}</div>
                        <div className={ styles.hpTopicCount }>{t.count}</div>
                        <span className={ styles.hpTopicArrow }>→</span>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default HomeTopics;

